export default __webpack_public_path__ + "static/media/courseblog.3f61e57e.webp";